import Fade from 'react-reveal/Fade';
import Rotate from 'react-reveal/Rotate';
import leahhenseler from '../img/thumbnails/leahhenseler.jpg'
import ihstsa from '../img/thumbnails/IHSTSA.jpg'
import humanitiesclass from '../img/thumbnails/Humanities Class.jpg'
import voncramm from '../img/thumbnails/Von Cramm.jpg'
import populationproject from '../img/thumbnails/Population Project.jpg'
import artporfolio from '../img/thumbnails/art.png'

function Work() {
    return (
        <Fade>
            <div className="Work section">
                <h2><Fade top><div>Works and Projects</div></Fade></h2>
                <h3><Fade top><div>Selected Websites</div></Fade></h3>
                <div className="grid">
                    <a href="https://leahhenseler.ml/" target="_blank"><Fade><img src={leahhenseler} alt="" /></Fade></a>
                    <a href="https://ihstsa.us/" target="_blank"><Fade><img src={ihstsa} alt="" /></Fade></a>
                    <a href="https://jyoon926.github.io/Humanities-Class/" target="_blank"><Fade><img src={humanitiesclass} alt="" /></Fade></a>
                    <a href="https://jyoon926.github.io/Population-Project/" target="_blank"><Fade><img src={populationproject} alt="" /></Fade></a>
                </div>
                <h3><Fade top><div>3D Art Portfolio</div></Fade></h3>
                <Fade><a href="https://www.instagram.com/jacobyoonart/" target="_blank" className="art"><div>Visit Page</div></a></Fade>
            </div>
        </Fade>
    );
}

export default Work;
